import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FiX, FiCheck } from "react-icons/fi";
import { toast } from "react-toastify";

import { getallVendors } from "../../../../Redux/actions/Operationsactions/getvendors";
import { buildPoState } from "./materialRequisitionsService";

const formatPkr = (num) => {
  return Number(num || 0).toLocaleString();
};

const BulkPoModal = ({ open, onClose, selectedRequisitions = [] }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const vendors = useSelector((s) => s.getAllVendors?.data || []);
  const [targetVendor, setTargetVendor] = useState("");
  const projectId = selectedRequisitions[0]?.projectId;

  useEffect(() => {
    if (projectId) {
      dispatch(getallVendors(projectId));
    }
  }, [dispatch, projectId]);

  if (!open || selectedRequisitions.length === 0) {
    return null;
  }

  const totalCost = selectedRequisitions.reduce((sum, r) => sum + (Number(r.estCost) || 0), 0);

  const totalItemsCount = selectedRequisitions.reduce(
    (sum, r) => sum + ((r.items && r.items.length) || 1),
    0,
  );

  const handleProceed = () => {
    const result = buildPoState(selectedRequisitions);
    if (result.error) {
      toast.error(result.error);
      return;
    }
    onClose();
    history.push("/procurement/purchase-order/add", {
      fromPurchaseRequisitions: result.fromPurchaseRequisitions,
      VendorId: targetVendor,
    });
  };

  return (
    <div className="req-modal-overlay" onClick={onClose}>
      <div className="req-modal-box" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="req-modal-header">
          <h5 className="req-modal-title m-0">Bulk Create Purchase Order</h5>
          <button type="button" className="req-modal-close" onClick={onClose} aria-label="Close">
            <FiX />
          </button>
        </div>

        {/* Body */}
        <div className="req-modal-body">
          <p style={{ color: "#475569", margin: "0 0 14px 0" }}>
            Consolidating <strong>{selectedRequisitions.length}</strong> requisition(s) with{" "}
            <strong>{totalItemsCount}</strong> material item(s) into a unified Purchase Order.
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              backgroundColor: "#f0fdfa",
              border: "1px solid #ccfbf1",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <div>
              <span style={{ fontSize: "12px", color: "#0f766e", fontWeight: 600 }}>
                Combined Estimated Cost
              </span>
              <div style={{ fontSize: "1.2rem", fontWeight: 700, color: "#0d9488" }}>
                PKR {formatPkr(totalCost)}
              </div>
            </div>
            <span
              style={{
                backgroundColor: "#0d9488",
                color: "#ffffff",
                padding: "4px 12px",
                borderRadius: "20px",
                fontSize: "12px",
                fontWeight: 600,
              }}
            >
              {selectedRequisitions.length} Requisitions
            </span>
          </div>

          <h6 style={{ fontWeight: 700, color: "#1e293b", marginBottom: "8px" }}>
            Included Requisitions
          </h6>
          <div
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              overflow: "hidden",
              marginBottom: "16px",
            }}
          >
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12.5px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                  <th style={{ padding: "8px 12px", textAlign: "left", color: "#475569" }}>
                    Req #
                  </th>
                  <th style={{ padding: "8px 12px", textAlign: "left", color: "#475569" }}>
                    Project
                  </th>
                  <th style={{ padding: "8px 12px", textAlign: "left", color: "#475569" }}>
                    Requested By
                  </th>
                  <th style={{ padding: "8px 12px", textAlign: "left", color: "#475569" }}>
                    Items Summary
                  </th>
                  <th style={{ padding: "8px 12px", textAlign: "right", color: "#475569" }}>
                    Est. Cost
                  </th>
                </tr>
              </thead>
              <tbody>
                {selectedRequisitions.map((req) => (
                  <tr key={req.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                    <td style={{ padding: "8px 12px", fontWeight: 600, color: "#0b6462" }}>
                      {req.reqNo}
                    </td>
                    <td style={{ padding: "8px 12px" }}>{req.project}</td>
                    <td style={{ padding: "8px 12px", color: "#64748b" }}>{req.requestedBy}</td>
                    <td style={{ padding: "8px 12px", whiteSpace: "pre-line", color: "#334155" }}>
                      {req.itemsSummary}
                    </td>
                    <td style={{ padding: "8px 12px", textAlign: "right", fontWeight: 600 }}>
                      {formatPkr(req.estCost)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ marginBottom: "12px" }}>
            <label className="filter-label-text" style={{ marginBottom: "6px", display: "block" }}>
              Assign Preferred Vendor / Supplier (Optional)
            </label>
            <select
              className="filter-control-select"
              value={targetVendor}
              onChange={(e) => setTargetVendor(e.target.value)}
            >
              <option value="">Select vendor on the Purchase Order form</option>
              {vendors.map((v) => (
                <option key={v.Id} value={v.Id}>
                  {v.Name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Footer */}
        <div className="req-modal-footer">
          <button
            type="button"
            className="btn_secondary"
            onClick={onClose}
            style={{ height: "36px", padding: "0 18px", borderRadius: "8px", fontWeight: 600 }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn_primary"
            onClick={handleProceed}
            style={{ height: "36px", padding: "0 18px", borderRadius: "8px", fontWeight: 600 }}
          >
            <FiCheck style={{ marginRight: "6px" }} /> Proceed to Create PO
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkPoModal;
